import { AuthLayout } from '../auth-layout/auth-layout'
import styles from './sign-in-page.module.scss'

export function SignInPage() {
  return (
    <AuthLayout>
      <h1 className={styles.heading}>Sign in to continue.</h1>
      <a href="/auth/slack" className={styles.button}>
        <SlackGlyph />
        <span>Continue with Slack</span>
      </a>
      <p className={styles.subtext}>Admin access required.</p>
    </AuthLayout>
  )
}

// Inline SVG — no icon-font dependency.
function SlackGlyph() {
  return (
    <svg
      className={styles.glyph}
      width="18"
      height="18"
      viewBox="0 0 122 122"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="currentColor"
        d="M25.8 77.6a12.9 12.9 0 1 1-12.9-12.9h12.9v12.9zm6.5 0a12.9 12.9 0 1 1 25.8 0v32.3a12.9 12.9 0 1 1-25.8 0V77.6z"
      />
      <path
        fill="currentColor"
        d="M45.2 25.8a12.9 12.9 0 1 1 12.9-12.9v12.9H45.2zm0 6.5a12.9 12.9 0 1 1 0 25.8H12.9a12.9 12.9 0 1 1 0-25.8h32.3z"
      />
      <path
        fill="currentColor"
        d="M97 45.2a12.9 12.9 0 1 1 12.9 12.9H97V45.2zm-6.5 0a12.9 12.9 0 1 1-25.8 0V12.9a12.9 12.9 0 1 1 25.8 0v32.3z"
      />
      <path
        fill="currentColor"
        d="M77.6 97a12.9 12.9 0 1 1-12.9 12.9V97h12.9zm0-6.5a12.9 12.9 0 1 1 0-25.8h32.3a12.9 12.9 0 1 1 0 25.8H77.6z"
      />
    </svg>
  )
}
